import SRD_DataTable from "components/DataTable";
import { useEffect, useState } from "react";

import { DateInput } from "@mantine/dates";

import { Button, Flex, Text } from "@mantine/core";
import { useQuery } from "react-query";
import { dateToString } from "utils/dateToString";

import { NumOfGroup, PAGE_SIZE } from "CommonData"; // src/CommonData.js
import { userGroupState } from "pages/Login/atom/userGroupState";
import { useNavigate } from "react-router-dom"; // SMS Sending Test
import { useRecoilValue } from "recoil";
import { getSmsSendList } from "../apis/sendListApis";

function SendListTable() {
  const navigate = useNavigate(); // SMS Sending Test
  const [page, setPage] = useState(1);
  const [pageSize] = useState(PAGE_SIZE);
  const [noOfGroup] = useState(NumOfGroup);
  const userGroup = useRecoilValue(userGroupState);

  const [range, setRange] = useState({
    start: new Date(new Date().getTime() - 7 * 24 * 60 * 60 * 1000),
    end: new Date(),
  });

  const [shouldFetch, setShouldFetch] = useState(false);

  useEffect(() => {
    setShouldFetch(false); // 컴포넌트가 마운트될 때 refetch를 방지합니다.
    console.log("userGroup updated:", userGroup);
  }, []);

  const { data, refetch } = useQuery(
    ["sendLists", userGroup, page, range.start, range.end],
    () => {
      console.log("API 호출 파라미터:", {
        userGroup,
        pageSize,
        page,
        startDate: dateToString(range.start),
        endDate: dateToString(range.end)
      });
      return getSmsSendList(userGroup, pageSize, page, dateToString(range.start), dateToString(range.end));
    },
    {
      enabled: shouldFetch,  // shouldFetch가 true일 때만 실행
      onSuccess: (data) => {
        console.log("API 응답 데이터:", data);
        if (shouldFetch && data.length === 0) {
          alert("SMS 발송 리스트가 없습니다.");
        }
        console.log("data > ", data);
        setShouldFetch(false);  // 데이터를 성공적으로 가져온 후 다시 false로 설정
      },
      onError: (error) => {
        console.error("API 에러:", error);
      },
      refetchOnMount: false, // 컴포넌트가 마운트될 때 refetch를 방지합니다.
    }
  );

  useEffect(() => {
    if (shouldFetch) {
      refetch(); // shouldFetch가 true일 때만 refetch 호출
    }
  }, [shouldFetch, refetch]);

  // 페이지 변경 시 자동으로 데이터 fetch
  useEffect(() => {
    if (page > 1) {
      refetch();
    }
  }, [page, refetch]);

  const DateRangePicker = () => {
    const handleStartChange = (date) => {
      setRange((prevState) => ({ ...prevState, start: date }));
    };

    const handleEndChange = (date) => {
      setRange((prevState) => ({ ...prevState, end: date }));
    };

    const onClick = () => {
      setShouldFetch(true);  // 검색 버튼 클릭 시 shouldFetch를 true로 설정
      refetch(); // refetch 호출
    };

    const onTestClick = () => {
      navigate("/sms/test");  // SMS Sending Test
    }

    return (
      <Flex gap={15} mb={10} align="center">
        {/* <Select data={bsdList ?? []} value={bsd} placeholder="분사 장치 선택" onChange={setBsd} /> */}
        <Text fw={500}>시작일</Text>
        <DateInput
          // label="시작일"
          value={range.start}
          onChange={handleStartChange}
          inputFormat="YYYY-MM-DD"
          inputProps={{
            rightSection: <i className="fas fa-calendar-alt"></i>,
          }}
        />
        <Text fw={500}>종료일</Text>
        <DateInput
          value={range.end}
          onChange={handleEndChange}
          inputFormat="YYYY-MM-DD"
          inputProps={{
            rightSection: <i className="fas fa-calendar-alt"></i>,
          }}
          minDate={range.start}
          maxDate={new Date()}
        />
        <Button onClick={() => onClick()}>검색</Button>
        <Button onClick={() => onTestClick()}>SMS Sending Test</Button>
      </Flex>
    );
  };

  const columns = [
    {
      accessor: "index",
      title: "번호",
      textAlignment: "center",
      width: 30,
      render: (record) => record?.rnum,
    },
    {
      accessor: "sent_date",
      title: "발송시간",
    },
    {
      accessor: "sms_telno",
      title: "연락처",
    },
    {
      accessor: "sms_content",
      title: "발송 메시지 내용",
    },
    {
      accessor: "sms_result",
      title: "발송결과",
    },
  ];

  return (
    <>
      <SRD_DataTable
        data={Array.isArray(data) ? data : []}
        columns={columns}
        searchBar={<DateRangePicker />}
        page={page}
        setPage={setPage}
      />
    </>
  );
}

export default SendListTable;
